import { Api } from "../../../../services/interceptor";
import { QUERY_KEY } from "../../../../services/queryEndPoint";
import { buildUpdateTournamentFields } from "./tournamentPayload";

function appendUpdateTournamentFormData(formData: FormData, fields: Record<string, unknown>) {
  for (const [key, value] of Object.entries(fields)) {
    if (value === null || value === undefined) continue;
    const stringValue = typeof value === "object" ? JSON.stringify(value) : String(value);
    formData.append(key, stringValue);
  }
}

/**
 * PUT /updateTournament — multipart/form-data (same style as updateLeague):
 * scalar fields as named parts + optional `bannerUri` file. No JSON on the query string.
 */
export async function updateTournamentRequest(args: {
  tournamentId: string;
  leagueId: string | null;
  draft: Record<string, unknown>;
  bannerFile?: File | null;
}): Promise<void> {
  const fields = buildUpdateTournamentFields(args.draft, args.tournamentId, args.leagueId);
  const formData = new FormData();
  appendUpdateTournamentFormData(formData, fields);
  if (args.bannerFile) {
    formData.append("bannerUri", args.bannerFile);
  }

  await Api.put(QUERY_KEY.updateTournament, formData);
}
